export const allOpportunities = [
  {
    id: "stem-for-others-1",
    title: "STEM Mentor and Chapter President",
    organization: "STEM For Others",
    location: ["Gilroy"],
    address: "N/A",
    major: [
      "Biology",
      "Business",
      "Communications",
      "Computer Science",
      "Engineering",
      "Environmental Science",
      "Psychology"
    ],
    focusArea: ["Children & Youth Community", "Education", "Technology"],
    type: ["Recurring"],
    image: "/images/stemforothers.png",
    website: "https://www.stemforothers.org",
    description: `Are you a high school student looking to make a difference in your community? Are you passionate about STEM and want to develop leadership skills for college and beyond? If this is you, please contact us as we're looking to start a new chapter in the Gilroy area.\n
    STEM for Others - Mission + Impact\n
    Our education system is failing to prepare students for success in an increasingly global and technology-driven world. This crisis is especially acute for students from under-resourced communities, who face persistent barriers to accessing high-quality STEM education.\n
    At STEM for Others, we believe STEM is the most powerful driver of upward mobility and opportunity in the 21st century. Our mission is to close the equity gap by delivering innovative, targeted, and accessible programs that empower every student.\n
    We have grown to over 30 chapters nationwide in the United States, teaching over 1,000 students each week thanks to a team of 800 volunteers. We need you to impact more communities.`,
    requirements: "4-5 hours per week\n Flexible to volunteer's schedule",
    datePosted: "June 3, 2025"
  }
];